<template>
  <v-container fluid>
    <Button color="primary" class="mobile-nav-open" type="submit" :click="toggleNav" buttonClass="pa-0 mt-n16 ml-n1"
      icon="mdi-menu-open" size="x-large" density="compact" v-if="isMobile" />
    <v-navigation-drawer v-model="nav" expand-on-hover rail :rail-width="navWidth" :permanent="!isMobile" :temporary="isMobile" :width="174">
      <v-list class="mb-2">
        <v-list-item class="pb-0">
          <Button color="primary" class="ml-2" type="submit" :click="newChat" buttonClass="pa-0 ml-1"
            icon="mdi-note-plus-outline" size="x-large" :tooltip="newChatLabel" density="compact" />
        </v-list-item>
      </v-list>
      <v-list class="history-list overflow-y-auto" density="compact">
        <v-list-item>
          <v-text-field
            class="history-list-filter mt-n6"
            v-model="reportFilter"
            name="filter"
            label="Filter"
            type="text"
            placeholder="Filter"
            variant="outlined"
            density="compact"
            hide-details="auto"
            clearable
            persistent-clear
          ></v-text-field>
        </v-list-item>
        <v-list-item v-for="({ id, title, updatedAt }, index) in chatsFiltered" :key="hash({ id, title, updatedAt, index })">
          <v-list-item-title class="history-list-item"><span class="click history-list-title text-body-2"
              @click="openChat(id)">{{ title }}</span>
            <div class="chat-menu">
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltip }">
                  <v-icon v-bind="tooltip" @click="reanalyze(id)" class="chat-reanalyze click ml-4" color="primary">mdi-refresh</v-icon>
                </template>
                <span>Reanalyze</span>
              </v-tooltip>
              <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltip }">
                  <v-icon v-bind="tooltip" @click="deleteChat(id)" class="chat-delete click ml-4"
                    color="primary">mdi-delete-forever-outline</v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list class="account-icon">
        <v-list-tiem>
          <v-btn
            v-if="!subscriptionActive"
            variant="plain" class="font-weight-black ml-0 shimmer-button" slim
            color="primary" size="x-large"
            to="/subscribe">
            <span class="animate-text">
              <span>U</span><span>P</span><span>G</span><span>R</span><span>A</span><span>D</span><span>E</span>
            </span>
          </v-btn>
        </v-list-tiem>
        <v-list-item v-if="isAdmin && !demoModeDisplay">
          <v-btn variant="plain" class="font-weight-black ml-n1" slim
            color="secondary" size="x-large"
            to="/admin" icon="mdi-account-cog-outline">
          </v-btn>
        </v-list-item>
        <v-list-item>
          <span class="d-inline account-icon-wrapper mb-8 ml-2">
            <v-tooltip location="top">
              <template v-slot:activator="{ props: tooltip }">
                <div class="user-icon smaller click" v-bind="tooltip" @click="openAccountDialog"><span
                    class="user-letter">{{ userLetter }}</span></div>
              </template>
              <span>Account</span>
            </v-tooltip>
          </span>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- start analysis cards -->
    <v-row :class="isMobile ? 'mt-n6' : ''">
      <v-col cols="1" class="chat-history-container mt-0 pt-0" v-if="!isMobile">

      </v-col>
      <v-col :cols="isMobile ? 12 : 10" :class="isMobile ? 'mt-0 pt-0 smaller-text' : 'mt-0 pt-0'">
        <div :class="chat.length === 0 ? 'chat-context mt-n8' : 'chat-context expanded mt-n8'">
          <div v-for="{ user, message }, index of chat" :key="hash({ user, message, time: Date.now() })" class="my-4">
            <Analysis v-if="index === 0" :id="id" :showEvents="index === 0" :userMessage="user" :agentMessage="message" :timestamp="timestamp" />
            <AnalysisExpanded v-else-if="index === 1" :id="id" :msg="message" :symbol="title" :timestamp="timestamp" />
            <ChatMessage v-else :id="id" :userMessage="user" :agentMessage="message" />
          </div>
        </div>
        <h2 :class="isMobile ? 'chat-title text-h5 mb-8' : 'chat-title text-h4 mb-8'" v-if="chat.length === 0">
          <span class="username">{{ usernameDisplay }}</span>{{ chatHeadline }}
        </h2>
        <v-autocomplete v-if="chat.length === 0"
          v-model="selectedStock" :items="stocksList"
          :menu-props="{ maxWidth: 0 }"
          item-title="label" item-value="symbol"
          variant="outlined" label="Select a stock"
          clearable
          persistent-clear
          class="stock-selector"> <!-- @update:modelValue="getAnalysis" -->
          <template v-slot:append>
            <v-tooltip location="top">
                <template v-slot:activator="{ props: tooltip }">
                  <v-icon v-bind="tooltip" :disabled="sendDisabled" @click="getAnalysis" :color="sendDisabled ? 'surface' : 'primary'" icon="mdi-send-variant-outline" size="x-large"></v-icon>
                </template>
                <span>Analyze</span>
              </v-tooltip>
          </template>
        </v-autocomplete>
        <!-- <v-text-field v-else-if="chat.length > 0" v-model="input" class="input" variant="outlined" @keydown.enter="sendChat">
          <template v-slot:append>
            <v-icon @click="sendChat" color="primary" icon="mdi-send-variant-outline" size="x-large"></v-icon>
          </template>
        </v-text-field> -->
      </v-col>
      <v-col cols="1" class="mt-0 pt-0" v-if="!isMobile">

      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="2">

      </v-col>
      <v-col cols="8">
        <v-text-field multi-line v-model="input" variant="outlined" @keydown.enter="sendChat">
          <template v-slot:append>
            <v-icon @click="sendChat" icon="mdi-send-variant-outline" size="x-large"></v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="2">

      </v-col>
    </v-row> -->
    <AccountDialog />
  </v-container>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
// import { marked } from 'marked'
// import Prism from 'prismjs'
// import 'prismjs/themes/prism-okaidia.css'
import { mapGetters, mapState } from 'vuex'
import CodeBlock from '@/components/CodeBlock.vue'
import Button from '@/components/Button.vue'
import { generateId, hash } from '@/utils/general'
import { FullTicker, SubscriptionInfo } from '@/utils/api'
import { ChatHistory, ChatInteraction, SubscriptionLocal } from '@/store'
import { mergeProps } from 'vue'
import AccountDialog from '@/components/AccountDialog.vue'
import Analysis from '@/components/Analysis.vue'
import AnalysisExpanded from '@/components/AnalysisExpanded.vue'
import ChatMessage from '@/components/ChatMessage.vue'

export interface LocalChatInteraction extends Omit<ChatInteraction, 'message'> {
  message: string | null
}

@Options({
  computed: {
    ...mapState(['username', 'isAdmin', 'firstname', 'remainingQuota', 'subscriptionInfo', 'demoModeDisplay']),
    ...mapGetters(['userChatHistory', 'contextForUser', 'stockFullTickerList']),
    breakpoint() {
      return this.$vuetify.display.name
    }
  },
  watch: {
    breakpoint(value: any) {
      this.updateNav()
    },
    async chat(values: LocalChatInteraction[]) {
      await this.saveChat()
    }
  },
  components: {
    CodeBlock,
    Button,
    AccountDialog,
    Analysis,
    AnalysisExpanded,
    ChatMessage
  }
})
export default class ChatView extends Vue {
  public username!: string
  public isAdmin!: boolean
  public demoModeDisplay!: boolean
  public authenticated!: boolean
  public firstname!: string
  public remainingQuota!: number
  public subscriptionInfo!: SubscriptionLocal
  public breakpoint!: string
  public contextForUser!: string
  public userChatHistory!: ChatHistory[]
  public stockFullTickerList!: FullTicker[]
  public id: string = generateId()
  public input: string = ''
  public timestamp = 0
  public title = ''
  public symbol = ''
  public chat: LocalChatInteraction[] = []
  public disableSend: boolean = false
  public showTyping = false
  public hash = hash
  public mergeProps = mergeProps
  public newChatLabel = 'New Analysis'
  public chatHeadline = ', enter a stock ticker to get started!'
  public selectedStock: string | null = null
  public nav = true
  public navWidthDesktop = '80'
  public navWidthModbile = '150'
  public reportFilter = ''

  beforeCreate() {}

  get usernameDisplay(): string {
    if (this.firstname == null || this.firstname == '') {
      return this.username
    } else if (this.firstname != null && this.firstname != '') {
      return this.firstname 
    }
    return this.username
  }

  get subscriptionActive() {
    if (this.subscriptionInfo == null) {
      return false
    }
    return this.subscriptionInfo.active
  }

  get subscriptionLevel() {
    if (this.subscriptionInfo == null) {
      return 'Trial'
    }
    return this.subscriptionInfo.level
  }

  get subscriptionEndDate() {
    if (this.subscriptionInfo == null) {
      return Date.now()
    }
    return this.subscriptionInfo.expires
  }

  get isMobile() {
    return this.breakpoint === 'xs' || this.breakpoint === 'sm'
  }

  get navWidth() {
    if (this.breakpoint == null) {
      return this.navWidthDesktop
    }
    return this.isMobile ? this.navWidthModbile : this.navWidthDesktop
  }

  public updateNav() {
    if (this.isMobile) {
      this.nav = false
    } else {
      this.nav = true
    }
  }

  public toggleNav() {
    this.nav = !this.nav
  }

  get userLetter() {
    if (this.usernameDisplay != null && this.usernameDisplay.trim().length > 0) {
      return this.usernameDisplay.charAt(0).toUpperCase()
    }
    return '?'
  }

  get chats(): ChatHistory[] {
    if (this.userChatHistory != null) {
      // chat history sorted by timestamp, most recent first
      return this.userChatHistory.sort((a, b) => b.timestamp - a.timestamp)
    }
    return []
  }

  get chatsFiltered(): ChatHistory[] {
    return this.chats.filter((chat) => chat.symbol.toLowerCase().includes((this.reportFilter ?? '').toLowerCase()))
  }

  get stocksList(): { symbol: string, name: string, label: string }[] {
    if (this.stockFullTickerList != null) {
      return this.stockFullTickerList.map(({ symbol, name }) => ({ symbol, name, label: `${symbol} ${name}` }))
    }
    return []
  }

  get sendDisabled() {
    return this.selectedStock == null || this.selectedStock === ''
  }

  openAccountDialog() {
    this.$store.dispatch('toggleOptions')
  }

  async created() {
  }

  async updated() {
  }

  async openChat(id: string) {
    const chat = this.userChatHistory.find((chat) => chat.id === id)
    if (chat != null) {
      this.id = chat.id
      this.title = chat.title
      this.symbol = chat.symbol
      this.timestamp = chat.timestamp
      this.chat = chat.history
      this.disableSend = false
      this.showTyping = false
      if (this.isMobile) {
        this.toggleNav()
      }
    }
  }

  async reanalyze(id: string) {
    await this.openChat(id)
    const symbol = this.symbol
    await this.deleteChat(id)
    await this.newChat(false)
    this.symbol = symbol
    this.input = symbol
    this.$store.dispatch('subscribeEvents', { id: this.id })
    if (this.isMobile) {
      this.toggleNav()
    }
    await this.sendChat()
  }

  async newChat(save: boolean = true) {
    if (save) {
      await this.saveChat()
    }
    this.id = generateId()
    this.timestamp = 0
    this.input = ''
    this.title = ''
    this.symbol = ''
    this.chat = []
    this.disableSend = false
    this.showTyping = false
    this.selectedStock = null
    if (this.isMobile) {
      this.toggleNav()
    }
  }

  async saveChat() {
    // console.log('saveChat called', this.chat.length)
    if (this.chat.length > 0) {
      // if (this.title === '') {
      //   const { success, response, message } = await this.$store.dispatch('getChatTitle', { input: this.chat[0].message, id: this.id })
      //   if (success) {
      //     this.title = response
      //   } else {
      //     this.title = 'New Chat'
      //   }
      // }
      await this.$store.dispatch('saveChatHistory', {
        id: this.id,
        username: this.username,
        timestamp: this.timestamp,
        updatedAt: Date.now(),
        title: this.title,
        history: this.chat
      })
    }
  }

  async mounted() {
    await this.$store.dispatch('getStockList')
    this.updateNav()
  }

  async getAnalysis() {
    if (this.remainingQuota != null && this.remainingQuota === 0) {
      this.$store.dispatch('showSnackbar', { message: 'You have reached your subscription quota for the month. Please upgrade your plan to continue.', icon: 'mdi-alert-circle' })
      return
    }
    this.input = this.selectedStock != null ? this.selectedStock : this.input
    const trimmed = this.input.trim()
    // check that we don't already have this symbol in the history list
    const found = this.chats.find(chat => chat.title === trimmed)
    if (found != null) {
      this.$store.dispatch('showSnackbar', { message: 'You already have an analysis for this stock. Reanalyzing...', icon: 'mdi-alert-circle' })
      this.reanalyze(found.id)
      return
    }
    if (trimmed.length >= 1 && trimmed.length <= 7) {
      this.$store.dispatch('subscribeEvents', { id: this.id })
      await this.sendChat()
    } else {
      this.$store.dispatch('showSnackbar', { message: 'Please enter a valid stock ticker', icon: 'mdi-alert-circle' })
    }
  }

  async sendChat() {
    this.showTyping = true
    const input = this.input
    if (this.title === '') {
      this.title = input
    }
    this.disableSend = true
    this.input = ''
    if (this.timestamp === 0) {
      this.timestamp = Date.now()
    }
    const timestamp = Date.now()
    const id = this.id
    const chat = { user: input, message: null, timestamp }
    this.chat.push(chat)
    const chatInput = this.chat.length === 1 ? input : input
    console.log(chatInput)
    await this.saveChat()
    const { success, response, message, analysis } = await this.$store.dispatch('sendChat', { input: chatInput, id })
    if (response != null) {
      console.log({response})
    }
    if (message != null) {
      console.log({message})
      this.$store.dispatch('showSnackbar', { message: `${message}. Please try again.`, icon: 'mdi-alert-circle' })
    }
    
    if (success) {
      this.chat.pop()
      this.chat.push({ user: input, message: response, timestamp })
      if (analysis != null) {
        this.chat.push({ user: input, message: analysis, timestamp })
      }
    }
    await this.saveChat()
    this.disableSend = false
    this.showTyping = false
  }

  async deleteChat(id: string) {
    await this.$store.dispatch('deleteChat', { id })
  }
}
</script>
<style scoped lang="scss">
.stock-selector {
  margin: auto;
  max-width: 500px;
}
.v-navigation-drawer {
  .chat-menu {
    display: none;
  }
  .chat-delete {
    display: none;
  }
  .chat-reanalyze {
    display: none;
  }
}

.history-list {
  max-height: 80%;
  scrollbar-width: none;
  // position: relative;

  .history-list-filter {
    position: absolute;
    opacity: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease, opacity 0.3s ease;
    max-width: 140px;
    width: 100%;
  }
  .history-list-title {
    transition: padding 0.3s ease
  }
}
.v-navigation-drawer--is-hovering {
  .history-list-filter {
    transform: translateX(0);
    opacity: 1;
  }
  .history-list-title {
    padding-left: 16px;
  }
  .chat-menu {
    display: inline;
  }
}
.v-tooltip :deep(.v-overlay__content) {
  font-size: 12px !important;
  font-weight: bold !important;
}
.click {
  cursor: pointer;
}

.mobile-nav-open {
  position: fixed;
  top: -20px;
  left: 0px;
}

.smaller-text {
  font-size: 80% !important;
  :deep(:not(.v-icon):not(.chat-title)) {
    font-size: inherit !important;
  }
}

.account-icon {
  position: fixed;
  bottom: 14px;
  left: 10px;
}

.history-list-item {
  &:hover {
    .history-list-title {
      color: rgb(var(--v-theme-primary));
      font-weight: bold;
    }
    .chat-reanalyze {
      display: inline;
    }
    .chat-delete {
      display: inline;
    }
  }
}

.chat-history-list {
  border: 1px solid #021822;
  border-radius: 8px;
  min-height: 70vh;
}

.chat-title {
  text-align: center;

  .username {
    color: rgb(var(--v-theme-primary));
    text-transform: capitalize;
    font-weight: bold;
  }
}

.chat-context.expanded {
  min-height: 70vh;
}

.chat-context {
  min-height: 25vh;
  padding: 20px 0;
  transition: height 0.9s ease;
}

.user-icon {
  width: 30px;
  height: 30px;
  background: rgb(var(--v-theme-primary));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.smaller {
    width: 27px;
    height: 27px;

    .user-letter {
      font-size: 14px;
    }
  }

  .user-letter {
    color: rgb(var(--v-theme-surface));
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
    text-transform: uppercase;
    user-select: none;
  }
}

// subscribe button text bounce
.animate-text {
  display: inline-flex;
  position: relative;
  z-index: 1;
  
  span {
    display: inline-block;
    animation: letterBounce 3.5s linear infinite;
  }

  span:nth-child(2) { animation-delay: 0.1s; }
  span:nth-child(3) { animation-delay: 0.2s; }
  span:nth-child(4) { animation-delay: 0.3s; }
  span:nth-child(5) { animation-delay: 0.4s; }
  span:nth-child(6) { animation-delay: 0.5s; }
  span:nth-child(7) { animation-delay: 0.6s; }
  // span:nth-child(8) { animation-delay: 0.7s; }
  // span:nth-child(9) { animation-delay: 0.8s; }
}



@keyframes letterBounce {
  0%, 40%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-4px);
  }
}

// subscribe button shimmer
.shimmer-button {
  span {
    color: rgb(var(--v-theme-primary));
  }
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.04) 50%,
      transparent 100%
    );
    border: none;
    opacity: 1;
    transform: translateX(-100%);
    animation: shimmerButton 10s infinite;
  }
}

@keyframes shimmerButton {
  0% {
    transform: translateX(-100%);
  }
  20% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>